module.exports = {
      id: "time-info-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#time-info",
      toString: function () {
        return this.url;
      }
    }